const dataFaqs = [
    {
        id: 1,
        title: 'How do I get on the guest list?',
        text: 'Just hit the RSVP link on our site or DM @nxtlvlnights on IG. We’ll get you locked in if you make the cut.',
        show: ''
    },
    {
        id: 2,
        title: 'What should I wear to a NXTLVL event?',
        text: 'Dress to impress — no slides, no gym fits. Think Miami meets luxury: clean, bold, and nightlife ready.',
        show: ''
    },
    {
        id: 3,
        title: 'How do I book a table or section?',
        text: 'Message us directly through IG @nxtlvlnights or use the booking form on the site. Bottle service is limited so don’t wait.',
        show: ''
    },
    {
        id: 4,
        title: 'Are your events 21+ only?',
        text: 'Yep — strictly 21 and over. We’re grown and the vibes are premium.',
        show: ''
    },
    {
        id: 5,
        title: 'Do you travel or host in other cities?',
        text: 'Yes. NXTLVL is based in Orlando, but we do pop-ups and takeovers across Florida and beyond.',
        show: ''
    },
    {
        id: 6,
        title: 'Can I collaborate or sponsor an event?',
        text: 'Absolutely. We’re always open to brand collabs. Hit us up through our collab form or DM to talk details.',
        show: ''
    },
    {
        id: 7,
        title: 'What music do you play at events?',
        text: 'Everything that keeps the party jumping — reggaeton, hip-hop, afrobeats, Latin trap, and more. No dead sets.',
        show: ''
    },
    {
        id: 8,
        title: 'What makes NXTLVL different?',
        text: 'We don’t just throw parties — we build experiences. Premium crowd, wild energy, top-tier production. There’s levels to this.',
        show: ''
    }
]

export default dataFaqs;